import React from 'react'
import { Encabezado } from '../../Components/Encabezado/Encabezado'
import { Box, Grid } from '@mui/material'

export const EncuestaNueva = () => {
  return (
    <Encabezado title={'CREAR NUEVA ENCUESTA'}>
        <Grid container spacing={2} justifyContent={'space-between'} >

        </Grid>
    </Encabezado>
  )
}
